import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import {encryptPassword} from "../../business/crypto/encode";
import getApiUrl from "../../requests/getUrl";
import getUrl from "../../requests/getUrl";
import logo from "../../assets/Logo_SAT_SAT_3.png"

function Login() {
    const [username, setUsername] = useState("");
    const [password, setPassword] = useState("");
    const [error, setError] = useState(null);
    const navigate = useNavigate();


    const submitLogin = async () => {
        setError(null);

        const encryptedPassword = await encryptPassword(password)
        const credentials = {
            username: username, password: encryptedPassword};
        try {

            const res = await fetch(getUrl()+"/api/login", {
                method: "POST",
                headers: {
                    "Content-Type": "application/json",
                },
                body: JSON.stringify(credentials),
                credentials: "include", 
            });

            if (res.status != 200 ){
                setError("Invalid login or password")
                return
            }


            const result = await res.json();
            console.log("Login result: ", result);
            if (result.message === "Login successful") {
                redirectToHome(); // Redirect on success
            } else {

                setError("Authentication error: Internal server error");
            }
        } catch (err) {
            setError("Authentication error: Internal server error");
        }
    };

    function redirectToHome() {
        console.log("Redirecting to home page");
        window.location.href = "/home"
    }
    const handleKeyDown = (e) => {
        if (e.key === "Enter") {
            submitLogin();
        }
    };

    return (
        <div className="page-wrapper"
        >
            <div className="background">
                <span></span>
                <span></span>
                <span></span>
                <span></span>
                <span></span>
                <span></span>
                <span></span>
                <span></span>
                <span></span>
                <span></span>
                <span></span>
                <span></span>
                <span></span>
                <span></span>
                <span></span>
                <span></span>
                <span></span>
                <span></span>
                <span></span>
                <span></span>
                <span></span>
                <span></span>
                <span></span>
                <span></span>
                <span></span>
                <span></span>
                <span></span>
                <span></span>
                <span></span>
                <span></span>
                <span></span>
                <span></span>
                <span></span>
                <span></span>
                <span></span>
                <span></span>
                <span></span>
                <span></span>
                <span></span>
                <span></span>
            </div>
            <div className="login-wrapper">
                <div className="login-form">
                    <div className="login-label">
                        <img
                            src={logo}
                        />
                        {/*<span className="login-label-main">SAT</span>*/}
                        {/*<span className="login-label-secondary">Delivery</span>*/}
                    </div>
                    <div className="login-input">
                        {/*<label className="login-input-label" htmlFor="input-username">Логін користувача</label>*/}
                        <input
                            id="input-username"
                            name="username"
                            className="login-input-field"
                            value={username}
                            onKeyDown={(e)=>handleKeyDown(e)}
                            onChange={(e) => setUsername(e.target.value)}
                            placeholder="Login"
                        />
                    </div>
                    <div className="login-input">
                        {/*<label className="login-input-label" htmlFor="input-password">Пароль</label>*/}
                        <input
                            id="input-password"
                            name="password"
                            className="login-input-field"
                            value={password}
                            onChange={(e) => setPassword(e.target.value)}
                            onKeyDown={(e)=>handleKeyDown(e)}
                            placeholder="Password"
                            type="password"
                        />
                    </div>
                    <button
                        type="submit"
                        className="login-button"
                        onClick={submitLogin}
                    >
                        Sign in
                    </button>
                         {error && (
                             <div
                                 style={{
                                     color: "red",
                                     fontSize: "0.9rem",
                                     marginBottom: "8px",
                                     textAlign: "center",
                                 }}
                             >
                                 {error}
                             </div>
                         )}
                </div>


            </div>
        </div>
    );
}

export default Login;
